import PropTypes from "prop-types";
import React, { Component } from "react";

//Simple bar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { API_WEB_URLS } from "constants/constAPI";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.refDiv = React.createRef();
    this.state = {
      loginDetails: []
    };
  }

  componentDidMount() {
    this.initMenu();
    const loginDetails = JSON.parse(sessionStorage.getItem("loginDetails")) || [];
    this.setState({ loginDetails });
    console.log("loginDetails", loginDetails);
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type || prevState.loginDetails !== this.state.loginDetails) {
      this.initMenu();
    }
  }

  // Group menu items by category
  groupMenuItemsByCategory = () => {
    const { loginDetails } = this.state;
    const groupedItems = {};

    loginDetails.forEach(item => {
      // Use the Menu property from sessionStorage data
      const category = item.Menu || this.getCategoryFromSubMenu(item.SubMenu);
      if (!groupedItems[category]) {
        groupedItems[category] = [];
      }
      groupedItems[category].push(item);
    });

    return groupedItems;
  };

  // Determine category based on SubMenu name
  getCategoryFromSubMenu = (subMenu) => {
    const subMenuLower = subMenu.toLowerCase();
    
    // Masters category
    if (subMenuLower.includes('itemtype') || 
        subMenuLower.includes('ply') || 
        subMenuLower.includes('paper') || 
        subMenuLower.includes('type') || 
        subMenuLower.includes('tax') || 
        subMenuLower.includes('gstgroup') || 
        subMenuLower.includes('city') || 
        subMenuLower.includes('financial') || 
        subMenuLower.includes('state') || 
        subMenuLower.includes('unit') || 
        subMenuLower.includes('ledger') || 
        subMenuLower.includes('consignee') || 
        subMenuLower.includes('calculation') || 
        subMenuLower.includes('print') ||
        subMenuLower.includes('height') ||
        subMenuLower.includes('length')) {
      return 'Masters';
    }
    
    // Transaction category
    if (subMenuLower.includes('invoice') || 
        subMenuLower.includes('receipt') || 
        subMenuLower.includes('party')) {
      return 'Transaction';
    }
    
    // Report category
    if (subMenuLower.includes('report') || 
        subMenuLower.includes('gst report') || 
        subMenuLower.includes('hsn')) {
      return 'Report';
    }
    
    // Sheet Sizing & Orders category
    if (subMenuLower.includes('sheet') || 
        subMenuLower.includes('order') || 
        subMenuLower.includes('sizing')) {
      return 'Sheet Sizing & Orders';
    }
    
    // Tools category
    if (subMenuLower.includes('user') || 
        subMenuLower.includes('rights') || 
        subMenuLower.includes('global') ||
        subMenuLower.includes('manage'))  {
      return 'Tools';
    }
    
    return 'Other';
  };

  // Get icon for category
  getCategoryIcon = (category) => {
    switch (category) {
      case 'Masters':
        return 'bx bx-cog';
      case 'Transaction':
        return 'bx bx-receipt';
      case 'Reports':
        return 'bx bx-bar-chart-alt-2';
      case 'SheetSizing & Orders':
        return 'bx bx-layer';
      case 'Tools':
        return 'bx bx-wrench';
      default:
        return 'bx bx-menu';
    }
  };

  // Render menu items for a category
  renderMenuItemsForCategory = (category, items) => {
    const CustomerId = API_WEB_URLS.Customer;
    
    // Special handling for SheetSizing & Orders category
    if (category === 'SheetSizing & Orders'  && CustomerId != 7 && CustomerId != 13 && CustomerId != 11 && CustomerId != 1) {
      return null;
    }

    return (
      <li key={category}>
        <Link to="/#" className="has-arrow">
          <i className={this.getCategoryIcon(category)} />
          <span>{this.props.t(category)}</span>
        </Link>
        <ul className="sub-menu" aria-expanded="false">
          {items.map((item, index) => (
            <li key={index}>
              <Link to={item.Path}>
                {this.props.t(item.SubMenu)}
              </Link>
            </li>
          ))}
          {/* Add customer-specific reports for Reports category */}
          {category === 'Reports' && this.renderCustomerSpecificReports()}
        </ul>
      </li>
    );
  };

  // Render customer-specific reports
  renderCustomerSpecificReports = () => {
    const CustomerId = API_WEB_URLS.Customer;
    
    // switch (CustomerId) {
    //   case 1:
    //     return (
    //       <>
    //         <li>
    //           <Link
    //             to={{
    //               pathname:
    //                 "https://boldreports.shinewellinnovation.com/reporting/site/site1/reports/b2bb8ada-0b3b-40d2-a28b-5b8a6ff2db02/TrueCartoons/InvoiceReport",
    //             }}
    //             target="_blank"
    //           >
    //             {this.props.t("Invoice Detail Report")}
    //           </Link>
    //         </li>
    //         <li>
    //           <Link
    //             to={{
    //               pathname:
    //                 "https://boldreports.shinewellinnovation.com/reporting/site/site1/reports/a688a03b-a4f4-4a01-a280-43e4af8aa1b3/TrueCartoons/GSTReport",
    //             }}
    //             target="_blank"
    //           >
    //             {this.props.t("GST Report")}
    //           </Link>
    //         </li>
    //         <li>
    //           <Link to="/EInvoiceReport">
    //             {this.props.t("EInvoice Report")}
    //           </Link>
    //         </li>
    //       </>
    //     );
    //   case 2:
    //     return (
    //       <>
    //         <li>
    //           <Link
    //             to={{
    //               pathname:
    //                 "https://boldreports.shinewellinnovation.com/reporting/site/site1/reports/a7f8a0c1-a445-40e5-b020-dd6217549d8b/Chandra/InvoiceReport",
    //             }}
    //             target="_blank"
    //           >
    //             {this.props.t("Invoice Detail Report")}
    //           </Link>
    //         </li>
    //         <li>
    //           <Link
    //             to={{
    //               pathname:
    //                 "https://boldreports.shinewellinnovation.com/reporting/site/site1/reports/ef11ab69-ae48-47bb-81c7-86500f92204d/Chandra/GSTReport",
    //             }}
    //             target="_blank"
    //           >
    //             {this.props.t("GST Report")}
    //           </Link>
    //         </li>
    //         <li>
    //           <Link
    //             to={{
    //               pathname:
    //                 "https://boldreports.shinewellinnovation.com/reporting/site/site1/reports/f69019f3-473b-4936-8fbc-0f52c4735b07/Chandra/GSTR",
    //             }}
    //             target="_blank"
    //           >
    //             {this.props.t("GSTR 1")}
    //           </Link>
    //         </li>
    //       </>
    //     );
    //   case 7:
    //     return (
    //       <li>
    //         <Link
    //           to={{
    //             pathname:
    //               "https://boldreports.shinewellinnovation.com/reporting/site/site1/reports/86eb9fdf-be83-47e3-bc56-191d2caa87d9/CgDemo/GSTReport",
    //           }}
    //           target="_blank"
    //         >
    //           {this.props.t("GST Report")}{" "}
    //         </Link>
    //       </li>
    //     );
    //   default:
    //     return null;
    // }
  };

  initMenu() {
    new MetisMenu("#side-menu");

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  // componentDidUpdate() {}

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300;
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = item => {
    item.classList.add("active");
    const parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      this.scrollElement(item);
      return false;
    }
    this.scrollElement(item);
    return false;
  };

  render() {
    const obj = JSON.parse( sessionStorage.getItem("authUser"));
    const CustomerId = API_WEB_URLS.Customer;
    const groupedItems = this.groupMenuItemsByCategory();

    return (
      <React.Fragment>
        <SimpleBar autoHide={false} className="h-100" ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{this.props.t("Dashboard")}</li>
              <li>
                
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/dashboard">{this.props.t("Dashboard")}</Link>
                  </li>
                  
                </ul>
              </li>

              <li className="menu-title">{this.props.t("Menu")}</li>
              {Object.keys(groupedItems).map(category => (
                this.renderMenuItemsForCategory(category, groupedItems[category])
              ))}
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));
